export default __webpack_public_path__ + "static/media/alexanderbrasserie.8fe11436.jpg";